import React from 'react';
import OdxModal from "../../../../OdxComponents/NativeOdx/Modal/Odx-Modal";
import OdxChip from "../../../../OdxComponents/NativeOdx/Odx-Chip";

interface LogEvent {
    date: string;
    time: string;
    level: string;
    message: string;
}

interface LogsProps {
    logs: LogEvent[];
    isOpen: boolean;
    onClose: () => void;
    idPrefix?: string;
}

const Logs: React.FC<LogsProps> = ({logs, isOpen, onClose, idPrefix = 'doop-logs-modal'}) => {
    const logsByDateTime = logs.reduce((acc: { [key: string]: LogEvent[] }, log) => {
        const dateTimeKey = `${log.date}_${log.time}`;
        if (!acc[dateTimeKey]) {
            acc[dateTimeKey] = [];
        }
        acc[dateTimeKey].push(log);
        return acc;
    }, {});

    return (
        <OdxModal
            size="small"
            variant="sidesheet"
            title="Logs"
            onClose={onClose}
            isOpen={isOpen}
            footerButtons={[]}
            id={idPrefix}
        >
            <div className="odx-modal__content">
                {Object.entries(logsByDateTime).map(([dateTime, events]) => {
                    const [date, time] = dateTime.split('_');
                    return (
                        <div key={dateTime} className="mb-4" id={`${idPrefix}-entry-${dateTime.replace(/[^a-zA-Z0-9]/g, '-')}`}>
                            <div className="flex justify-between items-center">
                                <h2 className="mb-2 text-xl font-semibold" id={`${idPrefix}-date-${dateTime.replace(/[^a-zA-Z0-9]/g, '-')}`}>{date}</h2>
                                <span className="text-gray-600" id={`${idPrefix}-time-${dateTime.replace(/[^a-zA-Z0-9]/g, '-')}`}>{time}</span>
                            </div>
                            {events.map((event, index) => (
                                <div key={index} className="flex items-center mb-2" id={`${idPrefix}-event-${dateTime.replace(/[^a-zA-Z0-9]/g, '-')}-${index}`}>
                                    <div className="mr-4">
                                        <OdxChip size="small" content={event.level} id={`${idPrefix}-event-level-${dateTime.replace(/[^a-zA-Z0-9]/g, '-')}-${index}`}/>
                                    </div>
                                    <span className="flex-1" id={`${idPrefix}-event-message-${dateTime.replace(/[^a-zA-Z0-9]/g, '-')}-${index}`}>{event.message}</span>
                                </div>
                            ))}
                        </div>
                    );
                })}
            </div>
        </OdxModal>
    );
};

export default Logs;
